import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
const _excluded = ["attachTo", "hasSlashCommands"];
import { useMemo } from 'react';
import FormattedMessage from 'I18n/components/FormattedMessage';
import UICoachingTips from 'ui-coaching-tips/UICoachingTips';
import { jsx as _jsx } from "react/jsx-runtime";
const initialSteps = [{
  content: /*#__PURE__*/_jsx(FormattedMessage, {
    message: "coachingTips.intro.content"
  })
}, {
  content: /*#__PURE__*/_jsx(FormattedMessage, {
    message: "coachingTips.highlightCommands.content"
  }),
  description: /*#__PURE__*/_jsx("strong", {
    children: /*#__PURE__*/_jsx(FormattedMessage, {
      message: "coachingTips.highlightCommands.description"
    })
  })
}];
const slashCommandStep = {
  content: /*#__PURE__*/_jsx(FormattedMessage, {
    message: "coachingTips.slashCommands.content"
  }),
  description: /*#__PURE__*/_jsx("strong", {
    children: /*#__PURE__*/_jsx(FormattedMessage, {
      message: "coachingTips.slashCommands.description"
    })
  })
};
const CommandCoachingTips = _ref => {
  let {
      attachTo,
      hasSlashCommands = false
    } = _ref,
    restCoachingTipsProps = _objectWithoutPropertiesLoose(_ref, _excluded);
  const steps = useMemo(() => {
    return [...initialSteps, ...(hasSlashCommands ? [slashCommandStep] : [])];
  }, [hasSlashCommands]);
  return /*#__PURE__*/_jsx(UICoachingTips, {
    config: {
      id: 'content-assistant-onboarding',
      tips: [Object.assign({}, restCoachingTipsProps, {
        title: /*#__PURE__*/_jsx(FormattedMessage, {
          message: "coachingTips.title"
        }),
        attachTo,
        steps
      })]
    }
  });
};
export default CommandCoachingTips;